import { Text } from "@clipboard-health/ui-react";
import { CardHeader, Container, IconButton, Link, Stack } from "@mui/material";
import { formatInTimeZone } from "date-fns-tz";

import { CbhIcon } from "../components/CbhIcon/CbhIcon";
import { SUPPORT_TELEPHONE } from "../ContactCBHInfo/constants";
import { useIsSmallScreen } from "./hooks/useIsSmallScreen";
import { type DateTimeSlot, type ShiftBoardWorkplace } from "./types";

export function ShiftBoardHeader(props: {
  workplace: ShiftBoardWorkplace;
  dateTimeSlot: DateTimeSlot;
  maxWidth?: number;
  canIncrement(): boolean;
  canDecrement(): boolean;
  incrementTimeSlot(): void;
  decrementTimeSlot(): void;
}) {
  const {
    workplace,
    dateTimeSlot,
    incrementTimeSlot,
    decrementTimeSlot,
    canIncrement,
    canDecrement,
    maxWidth,
  } = props;
  const { date, timeSlot } = dateTimeSlot;
  const isSmallScreen = useIsSmallScreen();
  return (
    <CardHeader
      title={
        <Container sx={{ maxWidth }} disableGutters={isSmallScreen}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" gap={1}>
              {canDecrement() && (
                <IconButton onClick={decrementTimeSlot}>
                  <CbhIcon type="chevron-left" size="xSmall" />
                </IconButton>
              )}
              <Text variant="h2">{formatInTimeZone(date, workplace.timeZone, "MMMM dd")}</Text>
              <Text bold variant="h2">
                {timeSlot.toUpperCase()}
              </Text>
              {canIncrement() && (
                <IconButton onClick={incrementTimeSlot}>
                  <CbhIcon type="chevron-right" size="xSmall" />
                </IconButton>
              )}
            </Stack>
            {!isSmallScreen && (
              <Stack direction="row" alignItems="center" gap={0.5}>
                <Text variant="body2">Need help? Call us:</Text>
                <Link href={`tel:${SUPPORT_TELEPHONE}`} underline="none">
                  <Text variant="body2" sx={{ color: "primary.main", fontWeight: "bold" }}>
                    {SUPPORT_TELEPHONE}
                  </Text>
                </Link>
              </Stack>
            )}
          </Stack>
        </Container>
      }
      subheader={
        <Container sx={{ maxWidth }} disableGutters={isSmallScreen}>
          <Stack
            direction={isSmallScreen ? "column" : "row"}
            alignItems={isSmallScreen ? "flex-start" : "center"}
            gap={isSmallScreen ? 1 : 2}
            maxWidth={maxWidth}
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <CbhIcon type="building" />
              <Text variant="h4">{workplace.name}</Text>
            </Stack>
          </Stack>
        </Container>
      }
      subheaderTypographyProps={{
        paddingTop: 2,
      }}
    />
  );
}
